// Hook do pobierania listy encji modułu DevStudio

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface IEntity {
  id: number;
  uuid: string;
  name: string;
  symbol: string;
  tableName: string;
  isActive: boolean;
}

interface IApiEntityItem {
  id: number;
  uuid: string;
  name: string;
  symbol: string;
  table_name: string;
  is_active: boolean;
}

interface IApiResponse {
  total_count: number;
  total_pages: number;
  items: IApiEntityItem[];
}

const getEntities = async (moduleUuid: string): Promise<IEntity[]> => {
  const response: IApiResponse = await axios.get<IApiResponse>(
    `/panel/dev-studio/entities/module/${moduleUuid}`,
    { params: { limit: 100 } }
  ) as unknown as IApiResponse;

  return (response?.items ?? []).map((item) => ({
    id: item.id,
    uuid: item.uuid,
    name: item.name,
    symbol: item.symbol,
    tableName: item.table_name,
    isActive: item.is_active
  }));
};

export const useGetEntities = (
  moduleUuid: string | null,
  options?: UseQueryOptions<IEntity[], IError>
) =>
  useQuery<IEntity[], IError>(
    ['entities', moduleUuid],
    () => getEntities(moduleUuid!),
    { ...options, enabled: !!moduleUuid }
  );
